<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col class="ma-0 pa-0" cols="12" sm="8"> </v-col>
        <v-col class="ma-0 pa-0 d-flex" cols="12" sm="4">
          <v-text-field
            class="mr-3 to-upper"
            :label="$t('search')"
            prepend-icon="mdi-magnify"
            v-bind:clearable="true"
            clear-icon="mdi-close"
            v-model="search"
            :outlined="is_boxes"
            :dense="is_boxes"
          ></v-text-field>
          <v-select
            multiple
            @change="fetchData"
            v-model="missionStatus"
            :items="missionStatuses"
            item-value="id"
            item-text="text"
            class="to-upper"
            clearable
            :label="$t('mission.status')"
            :outlined="is_boxes"
            :dense="is_boxes"
            :autocomplete="autocompleteValueLocal"
            :menu-props="{
              closeOnClick: false, // Important for multiple + checkboxes
              closeOnContentClick: false,
            }"
          >
            <!-- Item slot for dropdown options -->
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                :class="setMissionRowColorClass(item, true)"
                class="pa-0 ma-0 pl-2"
                style="color: black !important; width: 100%"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="missionStatus.includes(item.id)"
                    :ripple="false"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  {{ item.text }}
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <div>
        <v-data-table
          :height="'calc(-200px + 100vh)'"
          fixed-header
          :footer-props="{
            'items-per-page-options': dataTableOptions,
          }"
          :headers="headers"
          :items="missions"
          :options="options"
          :server-items-length="totalItems"
          :loading-text="this.$t('loading')"
          class="elevation-0"
          :items-per-page="itemsPerPage"
          item-key="identifier"
          @update:page="updatePagination"
          @update:items-per-page="updateItemsPerPage"
          @click:row="editItem"
          style="width: 100%"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @update:sort-by="updateSort"
          @update:sort-desc="updateSortOrder"
          mustSort
          :key="forceReloadComponentKey"
        >
          <template v-slot:item="{ item }">
            <tr :class="setMissionRowColorClass(item)" :key="item.id">
              <td @click="editItem(item)">{{ item.id || "-" }}</td>
              <td
                @click="openDocument(item)"
                class="pl-0 pr-0"
              >
                <template v-if="item.order_id">
                  <v-icon color="orange" right> mdi-file-document</v-icon>
                </template>
              </td>
              <td @click="editItem(item)">{{ item.identifier || "-" }}</td>
              <td @click="editItem(item)">
                <span v-if="item?.client?.name">
                  <v-icon size="12" color="primary">mdi-account</v-icon>
                  {{ item?.client?.name }}
                </span>
                <span v-else> </span>
                <span v-if="item?.towing_vehicle?.client">
                  <br />
                  <v-icon size="12" color="error">mdi-handshake</v-icon>
                  {{ item?.towing_vehicle?.client?.name }}
                </span>
                <span v-else>
                  <br />
                  <br />
                </span>
              </td>
              <td @click="editItem(item)">
                {{ item.reference?.toUpperCase() || "-" }}
              </td>
              <td @click="editItem(item)">
                <span v-if="item?.source_location">
                  <v-icon size="12" color="primary">mdi-crosshairs-gps</v-icon>
                  {{ item?.source_location?.human_readable_address }}
                </span>
                <span v-else>
                  <br />
                  <br />
                </span>
                <span v-if="item?.destination_location">
                  <br />
                  <v-icon size="12" color="error">mdi-map-marker</v-icon>
                  {{ item?.destination_location?.human_readable_address }}
                </span>
                <span v-else>
                  <br />
                  <br />
                </span>
              </td>
              <td @click="editItem(item)">
                {{
                  item?.mission_type?.key
                    ? $t("mission.types." + item?.mission_type?.key)
                    : ""
                }}
              </td>
              <td @click="editItem(item)">
                {{ currencySymbol }} {{ item?.price }}
              </td>
              <td @click="editItem(item)">
                {{
                  item?.status?.key
                    ? $t("mission.statuses." + item?.status?.key)
                    : ""
                }}
              </td>
              <td @click="editItem(item)">
                <template v-if="item.applications && item.applications.length > 0">
                    <v-tooltip bottom z-index="9999">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                v-on="on" 
                                v-bind="attrs"
                                small
                                class="primary"
                                
                            >
                                {{ item.applications.length }}
                            </v-chip>
                            </template>
                    {{ $t('mission.applications') }}
                </v-tooltip>
                </template>
              </td>
              <!-- <td @click="editItem(item)">
                    {{
                        item.created_at ? formatDateTime(item.created_at) : item.created_at
                    }}
                </td> -->
            </tr>
          </template>
        </v-data-table>
        <v-btn @click="fetchData" class="d-none" id="refresh-mission-listing"></v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import axios from "@/plugins/axios";
import _ from "lodash";
import { API_BASE_URL } from "@/config";
import { VIEW_MODE } from "@/config";
import { EDIT_MODE } from "@/config";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";

export default {
  name: "Missions",
  data() {
    return {
      autocompleteValueLocal: "off",
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      isLoading: true,
      totalItems: 0,
      lastPage: 1,
      sortBy: ["id"],
      sortDesc: true,
      sortOrd: "DESC",
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      missions: [],
      search: "",
      options: {},
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      missionStatuses: [],
      missionStatus: [],
      // header
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
    };
  },
  mounted() {
    (this.header = { Authorization: "Bearer " + this.token }),
      this.$store.commit("setFormMode", VIEW_MODE);
    this.getStatuses();
    this.fetchData();
  },
  created() {
    this.$watch(
      "search",
      _.debounce(() => {
        this.isLoading = true;
        this.fetchData();
      }, 500)
    );
  },
  watch: {},
  methods: {
    openDocument(item) {
      let url =
        API_BASE_URL +
        "/billings/" +
        item.order_id +
        "/print?document=order&lang=" +
        (localStorage.getItem("languageId") || "en") +
        "&user=" +
        localStorage.getItem("loginUserId");
      let fileName = item ? item?.identifier : "";
      this.setPreviewData(url, fileName, true, "application/pdf");
    },
    async getStatuses() {
      await this.getCodes("mission_statuses", "mission.statuses").then(
        (data) => {
          this.missionStatuses = data.filter((element) => {
            return !element.key.includes('selection');
          });
        }
      );
    },
    fetchData(currentPage = null) {
      this.resetDataTable(currentPage);
      this.isLoading = true;
      axios
        .get(
          API_BASE_URL +
            "/missions?page=" +
            this.page +
            "&items_per_page=" +
            this.itemsPerPage +
            (this.missionStatus && this.missionStatus.length > 0
              ? "&mission_statuses=" + this.missionStatus.join(",")
              : "") +
            (this.search
              ? "&search=" + encodeURIComponent(this.search)
              : "" + "&sortby=" + this.sortBy + "&sorttype=" + this.sortOrd),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.missions = data.data;
          this.lastPage = data.meta.last_page;
          this.totalItems = data.meta.total;
          this.page = data.meta.current_page;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    updatePagination(page) {
      this.page = page;
      this.fetchData(page);
    },
    updateItemsPerPage(itemsPerPage) {
      this.itemsPerPage = itemsPerPage == -1 ? this.totalItems : itemsPerPage;
      this.fetchData();
      this.itemsPerPage = this.itemsPerPage == -1 ? -1 : itemsPerPage;
    },
    editItem(item) {
      this.$store.commit("seteditId", item.id);

      this.$store.commit("setFormMode", EDIT_MODE);
      this.$router.push("/mission/edit").catch(() => {});
    },
    deleteItem() {
      console.log("Delete Item");
    },

    updateSort(sortBy) {
      console.log("data =>", sortBy);
      if (typeof sortBy == "object") {
        this.sortBy = sortBy[0];
      } else {
        this.sortBy = sortBy;
      }
      this.fetchData();
      console.log("sort by => ", this.sortBy);
    },
    updateSortOrder(sortDesc) {
      console.log("data => ", sortDesc);
      if (typeof sortDesc == "object") {
        !sortDesc[0] ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      } else {
        !sortDesc ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      }

      this.fetchData();
      console.log("sort order => ", this.sortOrd);
    },
    onSearch() {
      this.fetchData();
    },
  },
  computed: {
    currencySymbol() {
      return this.userCurrencySymbol;
    },
    headers() {
      return [
        { text: "ID", value: "id", sortable: true },
        { text: "", value: "icons", sortable: false },
        {
          text: this.$t("mission.identifier"),
          value: "identifier",
          sortable: false,
        },
        {
          text: this.$t("mission.client_towing_partner"),
          align: "start",
          sortable: false,
          value: "client_id",
        },
        {
          text: this.$t("mission.reference"),
          align: "start",
          sortable: false,
          value: "reference",
        },
        {
          text: this.$t("mission.location"),
          align: "start",
          sortable: false,
          value: "source_location_id",
        },
        {
          text: this.$t("mission.type"),
          align: "start",
          sortable: false,
          value: "mission_type_id",
        },
        {
          text: this.$t("mission.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: this.$t("mission.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: '',
          align: "start",
          sortable: false,
          value: "applications",
        },
      ];
    },
  },
};
</script>

<style scoped></style>
